import { Link } from 'react-router-dom';
import { cn } from '@/lib/cn';

export function Logo({ className, size = 'md' }: { className?: string; size?: 'sm' | 'md' }) {
  const img = size === 'sm' ? 'h-8 w-8' : 'h-9 w-9';
  const text = size === 'sm' ? 'text-lg' : 'text-xl';
  return (
    <Link to="/" className={cn('flex items-center gap-2.5', className)} aria-label="sqlmaster.uz">
      <img src="/logo.png" alt="sqlmaster.uz" className={cn(img, 'rounded-lg object-contain')} />
      <span className={cn('font-bold tracking-tight', text)}>
        sqlmaster<span className="text-[var(--brand-secondary)]">.uz</span>
      </span>
    </Link>
  );
}
